import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "15px",
      justifyContent: "center",
    },
  },
  title: {
    fontFamily: "Poppins",
    fontSize: "22px",
    fontWeight: 600,
    color: "#272525",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  toggleGroup: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    border: "1px solid #e0e0e0",
    "& .MuiToggleButtonGroup-grouped": {
      margin: "0 2px",
      border: 0,
      borderRadius: "8px !important",
      padding: "8px 24px",
      textTransform: "none",
      fontWeight: 600,
      color: "#666",
      "&.Mui-selected": {
        backgroundColor: "#4D1277",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#3a0d5a",
        },
      },
      "&:hover": {
        backgroundColor: "#f5f5f5",
      },
    },
  },
}));

export default useStyles;
